export default __webpack_public_path__ + "static/media/projects.48781691.svg";